import React, { useState, useRef, useEffect } from "react";
import { MoveRight } from "lucide-react";
import { CardCategoryProps } from "./CardCategoryProps";

const CardCaretory: React.FC<CardCategoryProps> = ({
  img,
  title,
  paragraph,
  link,
  width,
  height,
  tooltip,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState<"left" | "right">(
    "right"
  );
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handlePosition = () => {
      if (tooltipRef.current) {
        const rect = tooltipRef.current.getBoundingClientRect();
        if (rect.right + 300 > window.innerWidth) {
          setTooltipPosition("left");
        } else {
          setTooltipPosition("right");
        }
      }
    };

    handlePosition();
    window.addEventListener("resize", handlePosition);

    return () => {
      window.removeEventListener("resize", handlePosition);
    };
  }, [tooltip]);

    return (
        <React.Fragment>
            <div
                className="relative transition-all duration-300 ease-linear card hover:-translate-y-2 dark:bg-zink-600 shadow-2xl"
                onMouseEnter={() => tooltip && setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                ref={tooltipRef}
                style={{ zIndex: showTooltip ? 10 : 1 }}
            >
                <a href={link}>
                    <div className="p-3 flex flex-col justify-center items-center">
                        {img && (
                            <img
                                width={width ?? -1}
                                height={height ?? -1}
                                src={img}
                                alt=""
                            />
                        )}
                        <div className="mt-3">
                            {title && (
                                <h6
                                    className="mt-3 mb-2 text-center text-xs sm:text-xs md:text-sm"
                                >
                                    {title}
                                </h6>
                            )}
                        </div>
                    </div>
                </a>
                {tooltip && showTooltip && paragraph && (
                    <div
                        className={`absolute p-4 bg-blue-900 text-white text-md xs:text-xs sm:text-md rounded shadow-lg ${tooltipPosition === "right" ? "left-full ml-4" : "right-full mr-4"
                            }`}
                        style={{
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 20,
                            maxWidth: "400px", // Larger width for bigger tooltip
                            whiteSpace: "normal", // Allow wrapping of text
                        }}
                    >
                        {paragraph}
                    </div>
                )}
            </div>
        </React.Fragment>
  );
};

export default CardCaretory;
